var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 70,
    viewBox: "0 0 62 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 9C42.598 9 52 18.402 52 30C52 38.8926 46.4727 46.4942 38.6663 49.5567L32.1961 58.4007C32.0612 58.5858 31.8821 58.7369 31.6739 58.8412C31.4657 58.9455 31.2346 59 31 59C30.7654 59 30.5343 58.9455 30.3261 58.8412C30.1179 58.7369 29.9388 58.5858 29.8039 58.4007L23.3337 49.5567C15.5273 46.4941 10 38.8926 10 30C10 18.402 19.402 9 31 9Z",
    fill: "#D235BD"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 30C48 20.6112 40.3888 13 31 13C21.6112 13 14 20.6112 14 30C14 39.3888 21.6112 47 31 47C40.3888 47 48 39.3888 48 30Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8292 25.0829L35.0621 19.2578C35.3269 19.1417 35.6269 19.1355 35.8963 19.2405C36.0294 19.2932 36.1508 19.3718 36.2534 19.4716C36.356 19.5715 36.4379 19.6906 36.4943 19.8222L39.7443 27.4056C39.8575 27.6696 39.8611 27.9678 39.7545 28.2346C39.6478 28.5013 39.4396 28.7148 39.1755 28.828L31.6388 32.0574L32.9821 35.4157H37.6654V32.1657H39.832V40.8324H37.6654V37.5824H32.9821C32.0905 37.5824 31.3008 37.0472 30.9714 36.2196L29.6476 32.9111L25.9437 34.4981C25.6808 34.6111 25.384 34.6155 25.1179 34.5104C24.8518 34.4052 24.6381 34.1991 24.5234 33.937L21.2734 26.5086C21.1585 26.2458 21.1524 25.9481 21.2566 25.6808C21.3608 25.4136 21.5667 25.1985 21.8292 25.0829ZM20.4079 34.7354L22.4207 33.9316L20.2562 28.5149L18.2434 29.3176L20.4079 34.7354Z",
    fill: "#D235BD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 0.2,
    y: 0.2,
    width: 61.6,
    height: 69.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadar);
export default __webpack_public_path__ + "static/media/Radar.44342b9d412808beb190fb8785fca6b8.svg";
export { ForwardRef as ReactComponent };